import { pageHead } from "@/lib/seoPolicy";
import { createFileRoute } from "@tanstack/react-router";
import AdminLocationHeroVideo from "@/pages/admin/AdminLocationHeroVideo";

export const Route = createFileRoute("/admin/location-hero-video")({
  head: () => pageHead("Admin \u2014 Location Hero Video \u2014 Modern Fence Install", "Private Modern Fence Install account and management page.", undefined, true),
  component: AdminLocationHeroVideo,
});
